/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.kit.KitSourceType
*/
export var KitSourceType;
(function (KitSourceType) {
    KitSourceType["GIT"] = "GIT";
    KitSourceType["FOLDER"] = "FOLDER";
    KitSourceType["LIBRARY"] = "LIBRARY";
    KitSourceType["ODE"] = "ODE";
    KitSourceType["PROJECT"] = "PROJECT";
})(KitSourceType || (KitSourceType = {}));
//# sourceMappingURL=KitSourceType.js.map